import { render, staticRenderFns } from "./EventsPreview.vue?vue&type=template&id=4250ed12"
import script from "./EventsPreview.vue?vue&type=script&lang=ts"
export * from "./EventsPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports